
export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] rounded-t-[32px] mt-32">
      <div className="max-w-[1400px] mx-auto px-8 py-12">
        <div className="flex justify-center items-center">
          <p className="text-[#71717a] text-sm">© 2026 Omar Mohamed</p>
        </div>
      </div>
    </footer>
  );
}
